<template>
  <div>
    <div v-if="detail" class="detail-container">
      <div class="title">
        搜狐个人及企业投诉申请表（{{ detail.complaintNum }}）
      </div>
      <div class="subtitle">申请日期</div>
      <div class="content" v-if="getTime(detail.createTime)">
        {{ getTime(detail.createTime) }}
      </div>
      <div class="subtitle">申请人信息</div>
      <div class="content">
        申请人姓名（如单位/公司申请，请填写单位/公司名称及经办人姓名）：
        <span>{{ detail.name }}</span>
      </div>
      <div class="content">联系电话：{{ detail.phone }}</div>
      <div class="subtitle">投诉类型 ：{{ transferComplaintType(detail.complaintCategory) }}</div>
      <div class="subtitle">投诉内容 (填写申诉涉及的文章标题、网址等) ：</div>
      <div class="content">
        <div class="content" v-for="(item, idx) in detail.contents" :key="idx">
          <div class="content-item">{{ item.content }}</div>
          <div class="content-link">
            链接：<a class="link" :href="getLink(item.link)" target="_blank">
              {{ item.link }}
            </a>
          </div>
        </div>
      </div>
      <div class="subtitle">
        投诉处理状态
      </div>
      <div class="content">{{ statusMap[detail.status] || "无" }}</div>
      <div class="subtitle">
        投诉原因（对投诉原因的具体描述）
      </div>
      <div class="content">{{ detail.complaintReason || "无" }}</div>
      <div class="subtitle">
        投诉请求（对需要处理的段落，语句或处理要求的具体描述，全文删除请注明）：
      </div>
      <div class="content">
        {{ detail.complaintAppeal }}
      </div>
      <div class="subtitle">
        附件：
      </div>
      <div class="content" v-for="(item, idx) in detail.files" :key="idx">
        {{ idx + 1 }}.
        <a
          class="link"
          :href="getImgUrl(item)"
          :download="item.name"
          target="_blank"
        >
          {{ item.name }}
        </a>
      </div>
      <div class="subtitle">
        声明：
      </div>
      <div class="content">
        1、由以上操作所引起的一切后果，与搜狐网无关，由我本人/公司承担。
      </div>
      <div class="content">
        2、此传真中所包含的身份证复印件、营业执照复印件、单位/公司公章等本人保证全部真实且合法获得。
      </div>
      <div class="content">
        3、如非本人（本企业）申请，需提供相应的委托证明。
      </div>
      <!-- <div class="subtitle">
        申请人签名：
      </div>
      <div class="content">
        {{ detail.name }}
      </div> -->
      <div class="subtitle">
        申请表邮寄地址：
      </div>
      <div class="content">
        客服电话: 010-58511234
      </div>
      <div class="content">
        客服邮箱地址: kf@vip.sohu.com
      </div>
      <div class="content">
        收件人: 搜狐客服中心
      </div>
      <div class="content">
        地址: 北京市海淀区科学院南路2号院3号搜狐媒体大厦
      </div>
      <div class="content">
        邮编: 100084
      </div>
    </div>
    <div class="not-found" v-if="notFound">
      没有找到当前投诉
    </div>
  </div>
</template>

<script>
import HyPagination from "../../components/HyPagination";
import { getDetailById } from "../../api/audit";
import { complaintCategoryOption } from "@/utils/const";

const statusMap = {
  1: "提交中",
  2: "处理中",
  3: "已处理",
  4: "投诉无效"
};

export default {
  components: {
    HyPagination
  },
  created() {
    this.id = this.$route.params.id;
    // 真实请求
    if (!this.id) {
      this.notFound = true;
      return;
    }
    getDetailById({
      id: this.id
    }).then(res => {
      if (res.status === 100000 && res.data) {
        this.detail = res.data;
      } else {
        this.notFound = true;
      }
    });
  },
  data() {
    return {
      id: "",
      detail: null,
      statusMap: statusMap,
      notFound: false
    };
  },
  methods: {
    getLink(url) {
      if (url.indexOf("http://") !== 0 && url.indexOf("https://") !== 0) {
        return `http://${url}`;
      }
      return url;
    },
    getTime(time) {
      let arr = time && time.split(" ");
      return arr[0] || "";
    },
    getImgUrl(item) {
      return `${location.origin}/complaint-fe/api/sns-audit/sohucs/download/${item.csObjectId}`;
    },
    transferComplaintType(complaintType) {
      for(let obj of complaintCategoryOption) {
        if (obj.value == complaintType) {
          return obj.label;
        }
      }
      return "";
    }
  },
  computed: {
  }
};
</script>

<style lang="scss" scoped>
.detail-container {
  min-width: 960px;
  width: 70%;
  border-radius: 10px;
  border: 1px solid rgba(151, 151, 151, 1);
  margin: 0 auto;
  box-sizing: border-box;
  padding: 29px 32px 59px 32px;
  line-height: 1.5;
}
.title {
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(0, 0, 0, 1);
  letter-spacing: 1px;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
}
.subtitle {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
  margin-top: 35px;
}
.content {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 1.8;
  color: rgba(0, 0, 0, 1);
}
.nonage {
  margin-top: 5px;
  span {
    margin-right: 15px;
  }
}
.link {
  display: inline-block;
  color: rgba(66, 149, 210, 1);
}
.not-found {
  padding-top: 51px;
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #696969;
}
.content-item,
.content-link,
.content {
  word-break: break-all;
}
</style>
